import Layout from "../components/Layout";

const Contact = () => {
    
    return (
        <Layout>
            <div className="card  text-dark bg-light mb-3">
                <div class="card-header">
                    <div className="row">
                        <div className="col-12">
                            <h6><i class="bi bi-phone"></i> Contact Information</h6>
                        </div>                    
                    </div>
                </div>
                <div class="card-body">
                    <div className="row">
                        <div className="col-6">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Support</h5>
                                    <h6 class="card-subtitle mb-2" style={{color:'transparent'}}>Manager</h6>
                                    <h6 class="card-subtitle mb-2 text-muted">Software Support</h6>
                                    <a className="mt-2" href='mailto:support.sw@bitopibd.com'><i class="bi bi-envelope-check"></i> support.sw@bitopibd.com</a>
                                    <a className="mt-2 m-3" href='#'><i class="bi bi-phone"></i> +880 1623466666</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                        <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Parag Hossain</h5>
                                    <h6 class="card-subtitle mb-2">Executive-HR, OD & Training</h6>
                                    <h6 class="card-subtitle mb-2 text-muted">HR & Compliance | BITOPI GROUP</h6>
                                    <a className="mt-2" href='mailto:p.hossain@bitopibd.com'><i class="bi bi-envelope-check"></i> p.hossain@bitopibd.com</a>
                                    <a className="mt-2 m-3" href='#'><i class="bi bi-phone"></i> +880 1898-772-568</a>
                                </div>
                            </div>
                        </div>
                    </div>  
                    <br/> 
        
                </div>
            </div> 
        </Layout>
    )
}

export default Contact